<div class="flex">
  <div class="flex-item">
    <div style="display: block;">
    <canvas class="dashLine" baseChart
                [datasets]="lineChartData"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [legend]="lineChartLegendDasWor"
                [plugins]="lineChartPluginsDasWor"
                (chartClick)="chartClickedWork($event)"></canvas>
    <!-- <canvas class="dashLine" baseChart
                [datasets]="lineChartData"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"
                [plugins]="lineChartPlugins"
                (chartClick)="chartClicked($event)"></canvas> -->
    </div>
  </div>
</div>
